import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type { APIResponse, MatterRelatedMatter } from "@/lib/types";

type CreateMatterRelatedMatterConnectionPayload = {
  matterId: string;
  relatedMatterId: string;
};

export const createMatterRelatedMatterConnection = (
  data: CreateMatterRelatedMatterConnectionPayload,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterRelatedMatter>
    >(`${baseFastApiMatterRoute}/related-matters`, data)
    .then((res) => res.data);
};

export const deleteMatterRelatedMatterConnection = (data: { id: string }) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterRelatedMatter>
    >(`${baseFastApiMatterRoute}/related-matters/${data.id}`)
    .then((res) => res.data);
};
